import { StripeService } from './../../../../core/services/stripeService/stripe-service.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as saveAs from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.css'],
})
export class OfferDetailsComponent {
  offerId: any;
  detailsOffer: any;

  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  constructor(
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private stripeService: StripeService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getId();
    this.getDetailsOffer();
  }

  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.offerId = params.params['abonnementId'];
      },
    });
  }

  getDetailsOffer() {
    let dataPayload = this.offerId;
    this.spinner.show();
    this.stripeService
      .getAllDetailsOfAbonnement(dataPayload)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.detailsOffer = res?.data;
        },
        (error) => {
          this.spinner.hide();
          console.error('Error fetching detailsOffer:', error);
        }
      );
  }

  downloadInvoice(invoiceId: any, file?: File) {
    this.spinner.show();
      let data = invoiceId;
      this.stripeService.exportInvoice(file, data).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, 'Facture.pdf');
          this.spinner.hide();
          this.toastr.success('Fichier téléchargé avec succès');
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error('Erreur lors du téléchargement du fichier');
        },
      });
    }
  
}
